// No dependencies, so the app can import it.
export type InlineCitationRefs = {
  assumptionKeys: string[];
  referencedIds: string[];
  versionIds: string[];
};

export const INLINE_CITATIONS_TAG_NAME = "citations";

// Shared by stripping and validation so both agree on what counts as a tag.
export const INLINE_CITATIONS_OPEN_TAG_PATTERN = `<${INLINE_CITATIONS_TAG_NAME}(?=[\\s/>])(?:"[^"]*"|'[^']*'|[^>"'])*>`;

// Leading spaces and tabs go with the tag, so stripping leaves no gap before the line end.
const STRIP_REGEX = new RegExp(
  `[ \\t]*${INLINE_CITATIONS_OPEN_TAG_PATTERN}|<\\/${INLINE_CITATIONS_TAG_NAME}\\s*>`,
  "gi",
);

/** Drops a tag still being written at the end of streaming text, so it never shows as raw markup. */
export function withoutPartialInlineCitationAtEnd(markdown: string): string {
  const start = markdown.lastIndexOf("<");
  // A tag that already has its `>` renders as its custom component, so only an unfinished one is dropped.
  if (start === -1 || markdown.includes(">", start)) return markdown;
  const tail = markdown.slice(start).toLowerCase();
  const isPartialTag = [
    `<${INLINE_CITATIONS_TAG_NAME}`,
    `</${INLINE_CITATIONS_TAG_NAME}`,
  ].some((tag) => tag.startsWith(tail) || tail.startsWith(tag));
  return isPartialTag ? markdown.slice(0, start).trimEnd() : markdown;
}

export function parseInlineCitationList(value: string | undefined): string[] {
  if (!value) return [];
  return value
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}

export function stripInlineCitations(markdown: string): string {
  return markdown.replace(STRIP_REGEX, "");
}
